import api from '@/utils/api'
import Vue from 'vue'
import STATUS from '@/utils/status'
import _ from 'lodash'
import eventsBus from '@/components/shared/EventsBus'
import moment from 'moment'

const personalGroop = {
  id: -2,
  name: Vue.i18n.t('groups.personalGroups')
}
const state = {
  groops: [],
  selectedGroops: [],
  invitations: [],
  invitationsToAccept: [],
  status: STATUS.LOADING,
  personalGroop: personalGroop,
  fakeGroop: {
    // to make the difference between a selection of all groops and one groop when there is only one groop :)
    id: -2000,
    name: 'fakeGroop'
  }
}

eventsBus.$on(eventsBus.LANGUAGE_CHANGED, () => {
  state.personalGroop.name = Vue.i18n.t('groups.personalGroups')
})

let getGroopsIds = function(groops) {
  return _.join(
    _.map(groops, g => g.id),
    ','
  )
}

const mutations = {
  select(state, groops) {
    // for own groops => select groops with all data (canEdit, ...)
    // for otherGroop, keep it like this
    state.selectedGroops = groops.map(g => {
      let myGroup = _.find(state.groops, { id: g.id })
      if (myGroup) {
        return myGroup
      }
      return g
    })
  },
  setPersonalGroop(state, personalGroop) {
    state.personalGroop = personalGroop
    state.personalGroop.name = Vue.i18n.t('groups.personalGroups')
  },
  setGroops(state, groops) {
    const isAllGroopsSelected = state.groops && state.groops.length + 1 === state.selectedGroops.length
    state.groops = groops
    state.groops.unshift(state.fakeGroop)
    if (isAllGroopsSelected) {
      state.selectedGroops = [...groops, state.personalGroop]
    } else {
      state.selectedGroops = state.selectedGroops.map(x => state.groops.find(g => x.id === g.id)).filter(x => x != null)
      if (state.selectedGroops.length === 0) {
        state.selectedGroops = [...groops, state.personalGroop]
      }
    }
    groops.forEach(function(groop) {
      Vue.set(groop, 'eventTypes', false)
      if (typeof groop.storageSize === 'undefined') {
        Vue.set(groop, 'storageSize', 0)
      }
      if (typeof groop.storageMax === 'undefined') {
        Vue.set(groop, 'storageMax', 0)
      }
      if (typeof groop.storageEnd === 'undefined') {
        Vue.set(groop, 'storageEnd', 0)
      }
      if (typeof groop.inQuotaOrder === 'undefined') {
        Vue.set(groop, 'inQuotaOrder', true)
      }
    })
  },
  setStatus(state, status) {
    state.status = status
  },
  forgetEventTypes(state, group) {
    group.eventTypes = false
  },
  addNewGroop(state, groop) {
    if (_.find(state.groops, { id: groop.id }) !== undefined) {
      return
    }
    Vue.set(groop, 'members', groop.members)
    state.groops.push(groop)
  },
  addInSelection(state, groop) {
    state.selectedGroops.push(groop)
    if (
      state.selectedGroops.length === state.groops.length - 1 &&
      !_.find(state.selectedGroops, state.fakeGroop)
    ) {
      state.selectedGroops.push(state.fakeGroop)
    }
  },
  removeFromSelection(state, groop) {
    let size = state.selectedGroops.length
    state.selectedGroops = state.selectedGroops.filter(g => g !== groop)
    if (size !== state.selectedGroops.length) {
      state.selectedGroops = state.selectedGroops.filter(
        g => g !== state.fakeGroop
      )
    }
    if (state.selectedGroops.length === 0) {
      state.selectedGroops = state.groops
    }
  },
  removeGroop(state, groop) {
    let index = state.groops.indexOf(groop)
    if (index > -1) {
      state.groops.splice(index, 1)
    }
  }
}

const actions = {
  select(ctx, groops) {
    ctx.commit('select', groops)
  },
  reload(ctx, silently = false) {
    if (!silently) {
      console.log('hereee')
      ctx.commit('setStatus', STATUS.LOADING)
    }
    return new Promise((resolve, reject) => {
      if (!ctx.rootGetters['user/isConnected']) {
        ctx.commit('setGroops', [])
        ctx.commit('setStatus', STATUS.LOADED)
        resolve()
        return
      }
      api.get('/groups').then(response => {
        ctx.commit('setPersonalGroop', response.data.personalGroup)
        ctx.commit('setGroops', response.data.groups)
        ctx.commit('setStatus', STATUS.LOADED)
        ctx.dispatch('reloadInvitations')
        resolve()
      })
    })
  },
  addNewGroop(ctx, groop) {
    ctx.commit('addNewGroop', groop)
  },
  removeGroop(ctx, groop) {
    ctx.commit('removeGroop', groop)
    ctx.commit('removeFromSelection', groop)
  },
  addInSelection(ctx, groop) {
    if (ctx.getters.isAllGroopsSelected) {
      ctx.commit('select', [groop])
    } else {
      ctx.commit('addInSelection', groop)
    }
  },
  removeFromSelection(ctx, groop) {
    if (
      ctx.state.selectedGroops.length === 1 &&
      ctx.state.selectedGroops[0] === groop
    ) {
      ctx.dispatch('selectAllGroops')
    } else {
      ctx.commit('removeFromSelection', groop)
    }
  },
  selectAllGroops(ctx) {
    let newList = [...ctx.state.groops, ctx.state.personalGroop]
    // reselect only if not already all selected
    if (_.differenceBy(newList, ctx.state.selectedGroops, 'id').length !== 0) {
      ctx.dispatch('select', newList)
    }
  },
  selectAllGroopsIfSelectedIsNotMine(ctx) {
    if (ctx.getters.hasNotMyGroopsSelected) {
      ctx.dispatch('selectAllGroops')
    }
  },
  selectPersonalGroop(ctx) {
    ctx.dispatch('select', [ctx.state.personalGroop])
  },
  loadEventTypesForGroup(ctx, group) {
    if (!group.eventTypes) {
      api.get('group/' + group.id + '/eventTypes').then(response => {
        Vue.set(group, 'eventTypes', response.data.eventTypes)
        group.eventTypes[-1] = {
          standard: true,
          text: 'NEW_TYPE'
        }
      })
    }
  },
  reloadEventTypesForGroup(ctx, group) {
    ctx.commit('forgetEventTypes', group)
    ctx.dispatch('loadEventTypesForGroup', group)
  },
  publicGroopsWithTexts(ctx, texts) {
    return new Promise((resolve, reject) => {
      api
        .get('public/groups', {
          __canHaveNoToken: true,
          params: {
            withTexts: texts
          }
        })
        .then(response => resolve(response.data.publicGroups))
        .catch(reject)
    })
  },
  reloadInvitations(ctx) {
    return new Promise((resolve, reject) => {
      api.get('invitations')
      .then((response) => {
        ctx.state.invitations = _.sortBy(response.data.groups, (i) => 0 - i.infoInvitation.time)
        ctx.state.invitationsToAccept = response.data.needConfirmation
        _.each(response.data.groups, (g) => {
          Vue.set(g, 'status', STATUS.IDLE)
        })
        _.each(ctx.state.invitationsToAccept, (i) => {
          Vue.set(i, 'status', STATUS.IDLE)
        })
        resolve()
      })
      .catch(reject)
    })
  },
  getInvitationWithTrio(ctx, trio) {
    return new Promise((resolve, reject) => {
      let invit = _.find(ctx.state.invitations, { id: trio.gId })
      if (invit) {
        return resolve(invit)
      }
      api
        .get('invitation', {
          __canHaveNoToken: true,
          params: {
            uId: trio.userId,
            gId: trio.gId,
            token: trio.token
          }
        })
        .then(response => {
          Vue.set(response.data.group, 'status', STATUS.IDLE)
          ctx.state.invitations.push(response.data.group)
          resolve(response.data.group)
        })
        .catch(reject)
    })
  },
  acceptInvitation(ctx, invit) {
    let trio = {
      userId: invit.invitedMemberId,
      gId: invit.id,
      token: invit.infoInvitation.registrationKey
    }
    invit.status = STATUS.SAVING
    return new Promise((resolve, reject) => {
      api
        .post('invitation', {
          uId: trio.userId,
          gId: trio.gId,
          token: trio.token
        })
        .then(response => {
          ctx.dispatch('addNewGroop', response.data.group)
          invit.status = STATUS.SAVED
          resolve(response.data.group)
        })
        .catch(() => {
          invit.status = STATUS.ERROR
          reject()
        })
    })
  },
  declineInvitation(ctx, invit) {
    let trio = {
      userId: invit.invitedMemberId,
      gId: invit.id,
      token: invit.infoInvitation.registrationKey
    }
    invit.status = STATUS.CANCELING
    return new Promise((resolve, reject) => {
      api
        .delete('invitation', {
          data: {
            uId: trio.userId,
            gId: trio.gId,
            token: trio.token
          }})
        .then(response => {
          invit.status = STATUS.CANCELED
        })
        .catch(() => {
          invit.status = STATUS.ERROR
          reject()
        })
    })
  },
  confirmInvitation (ctx, invit) {
    invit.status = STATUS.SAVING
    return new Promise((resolve, reject) => {
      api.post('confirm/invitation', {
        iId: invit.id
      }).then((response) => {
        Vue.set(ctx.getters.getGroupWithId(response.data.group.id), 'members', null)
        invit.status = STATUS.SAVED
        resolve(response.data.group)
      })
      .catch(() => {
        invit.status = STATUS.ERROR
        reject()
      })
    })
  },
  refuseInvitation (ctx, invit) {
    invit.status = STATUS.CANCELING
    return new Promise((resolve, reject) => {
      api.post('refuse/invitation', {
        iId: invit.id
      }).then((response) => {
        // Vue.set(ctx.getters.getGroupWithId(response.data.group.id), 'members', null)
        invit.status = STATUS.CANCELED
        resolve(response.data.group)
      })
      .catch(() => {
        invit.status = STATUS.ERROR
        reject()
      })
    })
  },
  getAutoInvitationWithDuo (ctx, keyData) {
    // return new Promise((resolve, reject) => {
    //   let invit = _.find(ctx.state.invitations, {id: keyData.gId})
    //   if (invit) {
    //     return resolve(invit)
    //   }
    //   api.get('privateAutoInvitation', {
    //     __canHaveNoToken: true,
    //     params: {
    //       uId: trio.userId,
    //       gId: trio.gId,
    //       token: trio.token
    //     }
    //   }).then((response) => {
    //     Vue.set(response.data.group, 'status', STATUS.IDLE)
    //     ctx.state.invitations.push(response.data.group)
    //     resolve(response.data.group)
    //   })
    //   .catch(reject)
    // })
  }
}

const getters = {
  groopsAreLoaded(state) {
    return state.status === STATUS.LOADED
  },
  groops(state) {
    return state.groops.filter(g => g !== state.fakeGroop)
  },
  getGroupWithId(state) {
    return id => {
      if (parseInt(id) === -2) {
        return state.personalGroop
      }
      return _.find(state.groops, g => parseInt(g.id) === parseInt(id))
    }
  },
  groopsWithOwn(state) {
    return [state.personalGroop].concat(
      state.groops.filter(g => g !== state.fakeGroop)
    )
  },
  selectedGroops(state) {
    return state.selectedGroops.filter(g => g !== state.fakeGroop)
  },
  groopInSelection(state) {
    return groop => {
      return state.selectedGroops.indexOf(groop) > -1
    }
  },
  hasNotMyGroopsSelected(state) {
    for (let index in state.selectedGroops) {
      let groop = state.selectedGroops[index]
      if (_.isNil(_.find(state.groops, g => groop.id === g.id))) {
        return true
      }
    }
    return false
  },
  selectedGroopsString(state, getters) {
    if (getters.isAllGroopsSelected) {
      return Vue.i18n.t('groups.allGroups')
    }
    if (state.selectedGroops.length === 0) {
      return Vue.i18n.t('groups.noGroup')
    }
    if (state.selectedGroops.length > 1) {
      return Vue.i18n.t('groups.nGroups', {
        length: state.selectedGroops.length
      })
    }
    if (state.selectedGroops.length === 1) {
      return state.selectedGroops[0].name
    }
  },
  isAllGroopsSelected(state) {
    if (state.selectedGroops.length !== state.groops.length + 1) {
      return false
    }
    return _.isEqual(
      _.sortBy(state.selectedGroops, ['id']),
      _.sortBy([...state.groops, state.personalGroop], ['id'])
    )
  },
  isPersonalGroopSelected(state) {
    return (
      state.selectedGroops.length === 1 &&
      state.selectedGroops[0] === state.personalGroop
    )
  },
  personalGroop(state) {
    return state.personalGroop
  },
  firstSelectedGroop(state, getters) {
    if (getters.isAllGroopsSelected) {
      return null
    } else {
      return state.selectedGroops.length && state.selectedGroops[0]
    }
  },
  firstSelectedGroopId(state, getters) {
    if (getters.firstSelectedGroop !== null) {
      return getters.firstSelectedGroop.id
    } else {
      return null
    }
  },
  selectedGroopsId(state, getters) {
    if (getters.isAllGroopsSelected) {
      return '-1'
    } else {
      return getGroopsIds(getters.selectedGroops) || '-1'
    }
  },
  groupsPerType(state, getters) {
    let groupsAndType = {}
    getters.groopsWithOwn.forEach(group => {
      groupsAndType[group.type] = groupsAndType[group.type] || []
      groupsAndType[group.type].push(group)
    })
    return groupsAndType
  },
  groupsPerTypeAndUnused(state, getters) {
    const sixMonth = moment()
      .subtract(6, 'month')
      .unix()
    let groupsAndType = {}
    getters.groopsWithOwn.forEach(group => {
      if (group.lastNotificationTime < sixMonth) {
        groupsAndType['UNUSED'] = groupsAndType['UNUSED'] || []
        groupsAndType['UNUSED'].push(group)
      } else {
        groupsAndType[group.type] = groupsAndType[group.type] || []
        groupsAndType[group.type].push(group)
      }
    })
    for (let type in groupsAndType) {
      let groups = groupsAndType[type]
      groupsAndType[type] = groups.sort((group1, group2) =>
        group1.name.localeCompare(group2.name)
      )
    }
    return groupsAndType
  },
  allTypes() {
    return [
      'MUSIC',
      'WORK',
      'FRIENDSANDFAMILLY',
      'FREETIME',
      'SPORT',
      'ORGANISATION'
    ]
  },
  invitations(state) {
    return state.invitations
  },
  pendingInvitations (state) {
    return state.invitations.filter((i) => i.status !== STATUS.SAVED)
  },
  invitationsToAccept (state) {
    return state.invitationsToAccept
  },
  pendingInvitationsToAccept (state) {
    return state.invitationsToAccept.filter((i) => i.status !== STATUS.SAVED)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  getGroopsIds
}



// WEBPACK FOOTER //
// ./src/store/groops.js